import { ModalOptions } from '@ionic/core';
import { showGlobalModal } from './global-modal';

export const checkIfEmailVerifiedAndRequired = () => async (
  dispatch,
  _getState
) => {
  const {
    user: { entitlements },
    auth: { user },
  } = _getState() as SworkitState;
  if (
    entitlements?.allowPremium?.requireEmailVerification &&
    !user.emailVerified
  ) {
    return dispatch(requestVerification());
  }
};

export const requestVerification = () => async (dispatch, _getState) => {
  const {
    ui: { globalModalShown },
  } = _getState() as SworkitState;
  const modalOptions: ModalOptions = {
    component: 'ion-nav',
    backdropDismiss: false,
    componentProps: {
      root: 'sw-confirm-required-page',
    },
  };
  if (!globalModalShown) {
    dispatch(showGlobalModal(modalOptions));
  }
};
